import { Stack, Typography } from '@mui/joy';
import { useTranslation } from 'react-i18next';

import { IVendor } from 'contacts/types';
import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { LabeledValue } from 'core/elements';
import { Color, Direction, Level } from 'theme/enums';

const LABEL_OPTIONS = { labelLevel: Level.BODY_SM, labelSx: { fontWeight: 400 }, inline: true };

interface IProps {
  vendor: IVendor;
}

export const LegacyVendorCard = ({ vendor }: IProps) => {
  const { t } = useTranslation();

  return (
    <Stack
      sx={{
        gap: 0.5,
        padding: '12px 16px',
        backgroundColor: 'neutral.50',
        border: '1px solid',
        borderColor: 'neutral.200',
        borderRadius: '6px',
        width: '100%',
      }}
    >
      <Stack direction={Direction.ROW} sx={{ flexWrap: 'wrap', gap: 0.5 }}>
        <Typography level={Level.TITLE_MD} color={Color.PRIMARY}>
          {vendor?.vendorName || DEFAULT_PLACEHOLDER}
        </Typography>
      </Stack>

      <LabeledValue
        label={t('labelSupplierName')}
        value={vendor?.vendorName || DEFAULT_PLACEHOLDER}
        options={LABEL_OPTIONS}
      />

      <LabeledValue
        label={t('labelSupplierNumber')}
        value={vendor?.vendorId || DEFAULT_PLACEHOLDER}
        options={LABEL_OPTIONS}
      />
    </Stack>
  );
};
